import { getIdOrNull } from '..'
import apiClient from './apiClient'

/** The note column is a varchar(255) on the API side. */
export const NOTE_MAX_LENGTH = 255

const fetchInternshipNote = (user, internship) => apiClient.get(user, `api/internships/${getIdOrNull(internship)}/internship-notes`)

const upsertInternshipNote = (user, internship, note) => apiClient.post(user, `api/internships/${getIdOrNull(internship)}/internship-notes`, { note })

const deleteInternshipNote = (user, internship) => apiClient.delete(user, `api/internships/${getIdOrNull(internship)}/internship-notes`)

export {
  fetchInternshipNote,
  upsertInternshipNote,
  deleteInternshipNote
}
